import {
  Inventories_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  Inventories_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD,
  Inventories_MASSIVE_UPLOAD_REQUEST_VERIFY,
  Inventories_MASSIVE_UPLOAD_SET_VERIFY,
  Inventories_MASSIVE_UPLOAD_CLEAR_VERIFY,
  Inventories_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  Inventories_MASSIVE_UPLOAD_SET_UPLOAD,
  Inventories_MASSIVE_UPLOAD_CLEAR_UPLOAD,
} from '../actions';

function InventoriesMassiveUploadReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    case Inventories_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: action.payload,
      };

    case Inventories_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: null,
      };

    case Inventories_MASSIVE_UPLOAD_REQUEST_VERIFY:
      return {
        ...state,
        isLoading: true,
        verify: null,
      };

    case Inventories_MASSIVE_UPLOAD_SET_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: action.payload,
      };

    case Inventories_MASSIVE_UPLOAD_CLEAR_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: null,
      };

    case Inventories_MASSIVE_UPLOAD_REQUEST_UPLOAD:
      return {
        ...state,
        isLoading: true,
        upload: null,
      };

    case Inventories_MASSIVE_UPLOAD_SET_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: action.payload,
      };

    case Inventories_MASSIVE_UPLOAD_CLEAR_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: null,
      };

    default:
      return state;
  }
}

export default InventoriesMassiveUploadReducer;
